// Style your elements here
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-item: center;
  text-align: center;

  height: 100vh;
  width: 100vw;
  background-image: linear-gradient(
    to ${prop => prop.direction},
    ${prop => prop.colorFirst},
    ${prop => prop.colorSecond}
  );
  font-family: Roboto;
  background-size: cover;
`
export const Heading = styled.h1`
  color: white;
`

export const Para = styled.p`
  color: #ededed;
`

export const Button = styled.button`
  background-color: #00c9b7;
  color: white;
  text-align: center;
  border: none;
  padding: 3px;
  width: 100px;
  margin-top: 10px;
`
export const Ul = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  alien-item: center;
`
export const Input = styled.input`
  outline: none;
`

export const Container1 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-item: center;
  text-align: center;
`
export const Container2 = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  align-item: center;
  text-align: center;
  margin: 5px;
`
export const Label = styled.label``
